<template>
  <form
    class="email-form"
    @submit.prevent="!errors.length && $emit('submit', email)"
  >
    <UiInput
      v-model="email"
      v-bind="emailAttrs"
      placeholder="e-mail"
      class="email-form__input"
      :label="$t('label.email')"
      :error="
        (!!errors.email && $t('error.email')) ||
        (emailErrorMessages && $t(emailErrorMessages))
      "
      @input="setFieldError('email', undefied)"
    />
    <UiButton
      :disabled="!email"
      :loading="loading"
      type="submit"
      class="email-form__button"
    >
      {{ $t('button.get_code') }}
    </UiButton>
  </form>
</template>

<script setup>
import { useForm } from 'vee-validate';
import * as yup from 'yup';

defineProps({
  emailErrorMessages: {
    type: String,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['submit', 'reset-email-error']);

const { errors, defineField, setFieldError } = useForm({
  validationSchema: yup.object({
    email: yup.string().email(),
  }),
});

const [email, emailAttrs] = defineField('email', {
  validateOnModelUpdate: false,
});
</script>

<style lang="scss">
.email-form {
  width: 100%;
  display: grid;
  grid-row-gap: 16px;

  &__input .input,
  &__button {
    width: 100%;
  }
}
</style>
